import {useEffect, useRef} from 'react';

import {useDispatch} from '~/lib/hooks';
import {setCalendarCtx} from '~/actions';

export const useCalendarNavigation = ({
  navigation,
  isFocused,
  visibleIndex,
  forceRerender,
  weekListViewRef,
}) => {
  const dispatch = useDispatch();

  const saveOffset = useRef(null);

  useEffect(() => {
    const unsubscribe = navigation.addListener('tabPress', () => {
      if (isFocused) {
        saveOffset.current = -1;
      }
    });

    return unsubscribe;
  }, [isFocused, navigation]);

  useEffect(() => {
    if (visibleIndex === null) {
      return;
    }

    const layoutManager =
      weekListViewRef.current?._virtualRenderer.getLayoutManager();
    if (layoutManager) {
      weekListViewRef.current?.scrollToIndex(visibleIndex - (visibleIndex % 7));
      forceRerender();
    }
  }, [visibleIndex, forceRerender, weekListViewRef]);

  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      dispatch(
        setCalendarCtx(saveOffset.current > 0 ? saveOffset.current : null),
      );
    };
  }, [dispatch]);

  return {saveOffset};
};
